<template>
  <nav class="flex items-center text-sm text-muted-foreground space-x-1 mb-2" aria-label="Breadcrumb">
    <ol class="flex items-center">
      <li v-for="(item, index) in items" :key="index" class="flex items-center">
        <AppIcon
          v-if="index !== 0"
          name="chevron-right"
          class="mx-2 text-muted-foreground h-3 w-3"
          aria-hidden="true"
        />
        <span v-if="(!item.onClick && !item.href) || index === items.length - 1" class="text-foreground font-medium" aria-current="page">
          {{ truncateLabel(item.label) }}
        </span>
        <router-link
          v-else-if="item.href"
          :to="item.href"
          class="hover:text-foreground transition-colors underline underline-offset-4"
          @click="item.onClick && item.onClick($event)"
        >
          {{ truncateLabel(item.label) }}
        </router-link>
        <button
          v-else
          class="hover:text-foreground transition-colors underline underline-offset-4 bg-transparent border-0 p-0 cursor-pointer"
          type="button"
          @click="item.onClick"
        >
          {{ truncateLabel(item.label) }}
        </button>
      </li>
    </ol>
  </nav>
</template>

<script setup>
defineProps({
  items: {
    type: Array,
    required: true,
    validator: (val) =>
      val.every(
        (item) => {
          if (typeof item.label !== 'string') return false
          if ('onClick' in item && typeof item.onClick !== 'function') return false
          if ('href' in item && typeof item.href !== 'string' && typeof item.href !== 'object') return false
          return true
        }
      ),
  },
})

const truncateLabel = (label) =>
  label.trim().length > 50 ? `${label.trim().slice(0, 50)}…` : label.trim()
</script>